module.exports = __webpack_public_path__ + "img/button_bg.2cfd1774.png";